export const appealStatuses = {
    pending: 'pending',
    approved: 'approved', // success
    rejected: 'rejected', // error
    executed: 'executed' // done
};
export const chargebackStatuses = {
    pending: 'pending',
    accepted: 'accepted',
    rejected: 'rejected'
};
export const fraudStatuses = {
    pending: 'pending',
    accepted: 'accepted',
    rejected: 'rejected'
};
export const approvalStates = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected'
};

export const callbackStatuses = {
    init: 'init',
    retry: 'retry',
    success: 'success',
    failed: 'failed'
};

export const cryptoDirections = {
    in: 'in',
    out: 'out'
};

export const dimensions = {
    percent: 'percent',
    fixed: 'fixed'
};

export const directions = {
    deposit: 'deposit',
    withdrawal: 'withdrawal'
};

export const instanceStates = {
    new: 'new',
    initialize: 'initialize',
    refused: 'refused',
    sum_blocked: 'sum_blocked',
    awaiting_3ds: 'awaiting_3ds',
    processed: 'processed',
    partially_refunded: 'partially_refunded',
    refunded: 'refunded',
    cancelled: 'cancelled',
    awaiting_processing: 'awaiting_processing',
    awaiting_withdraw: 'awaiting_withdraw',
    withdrawed: 'withdrawed',
    withdraw_cancelled: 'withdraw_cancelled',
    awaiting_confirmation: 'awaiting_confirmation'
};

export const orderStatuses = {
    open: 'open',
    initialize: 'initialize',
    payment_initiated: 'payment_initiated',
    payment_final: 'payment_final',
    payment_success: 'payment_success',
    expired: 'expired',
    fraud: 'fraud',
    refused: 'refused',
    processed: 'processed',
    cancelled: 'cancelled',
    awaiting_processing: 'awaiting_processing',
    error: 'error'
};

export const processingStates = {
    pending: 'pending',
    processed: 'processed',
    rejected: 'rejected'
};

export const refundStates = {
    initialize: 'initialize',
    processed: 'processed',
    refused: 'refused'
};

export const sexes = {
    male: 'male',
    female: 'female',
    other: 'other'
};

export const systemRoles = {
    appz: 'appz',
    merchant: 'merchant',
    psp: 'psp',
    agent: 'agent'
};

export const terminalFlags = {
    payment: 'payment',
    payout: 'payout',
    p2p: 'p2p'
};

export const costType = {
    merchant: 'merchant',
    gateway: 'gateway',
    agent: 'agent'
};
export const cascadingStatuses = {
    cascade_current: 'cascade_current',
    cascade_cancelled: 'cascade_cancelled',
    cascade_final: 'cascade_final'
};

export const withdrawalKinds = {
    revenue: 'revenue',
    expenses: 'expenses'
};

export const calculationTypes = {
    included_in_price: 'included_in_price',
    on_top_of_price: 'on_top_of_price',
    payout_included_in_price: 'payout_included_in_price',
    payout_on_top_of_price: 'payout_on_top_of_price',
    refund: 'refund',
    chargeback: 'chargeback',
    fraud: 'fraud',
    decline: 'decline',
    agent_type: 'agent_type'
};
//  "processedStatuses": "charged,complete,success,processed",
export const processedStatuses = {
    charged: 'charged',
    complete: 'complete',
    success: 'success',
    processed: 'processed'
};
//public enum ValidationTaskStatus {
//    pending, ready, rejected
// }
export const validationTaskStatuses = {
    pending: 'pending',
    ready: 'ready',
    rejected: 'rejected'
};